import { Component, Input, OnInit, Output, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { MatDialog } from '@angular/material/dialog';
import { OddModel } from './sports.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'longterm-component',
  templateUrl: '../sharedTemplates/longterm.component.html',
})
export class LongTermComponent implements OnInit, AfterViewInit {
  tourid = 0;
  tournamentId = 0;

  constructor(
    private _UiHelper: UiHelper,
    private _ApiService: ApiService,
    private _route: ActivatedRoute,
    private _router: Router,
    public _UserHelper: UserHelper,
    public _LocalizationService: LocalizationService,
    public _DataHelper: DataHelper,
    public _MatDialog: MatDialog
  ) {}

  private subscriptionsToStopOnDestroy: Subscription[] = [];

  ngOnInit() {
    if (this.tournamentId === 0) {
      this._route.params.subscribe(params => {
        this.tourid = params['tourid'];
        this._DataHelper.isOutRights = true;
      });
    }
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('Outrights', true);
    //Scroll Top
    const elementList = document.querySelectorAll('.breadcrumb-left');
    const element = elementList[0] as HTMLElement;
    element.scrollIntoView({ behavior: 'smooth' });
    //Scroll Top
  }
}
